var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',_vm._b({staticClass:"tasks-list-card",scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',{staticClass:"card-v2__title"},[_vm._v(_vm._s(_vm.$tc('task', 2)))]),_c('CheckboxComponent',{attrs:{"label":_vm.$t('showCompleted')},model:{value:(_vm.showDone),callback:function ($$v) {_vm.showDone=$$v},expression:"showDone"}}),_c('TaskCreateButton',{attrs:{"reference":_vm.reference}})]},proxy:true},{key:"default",fn:function(){return [_c('TaskList',{attrs:{"columns":[
        { id: 'title', label: _vm.$t('title') },
        { id: 'status', label: _vm.$t('status') },
        { id: 'dueAt', label: _vm.$t('deadline') },
        { id: 'type', label: _vm.$tc('type') },
        { id: 'members', label: _vm.$tc('member', 2) },
        { id: 'updatedAt', label: _vm.$t('lastUpdated') },
      ],"filter":{
        references: { onModel: _vm.reference.onModel, ref: _vm.reference.ref, inherit: true },
        status: _vm.showDone ? [] : ['!done'],
      },"theme":"border","select":false}})]},proxy:true}])},'Card',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }